import { render, staticRenderFns } from "./Workbenchsingle.vue?vue&type=template&id=efef3558&scoped=true&"
import script from "./Workbenchsingle.vue?vue&type=script&lang=js&"
export * from "./Workbenchsingle.vue?vue&type=script&lang=js&"
import style0 from "./Workbenchsingle.vue?vue&type=style&index=0&id=efef3558&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efef3558",
  null
  
)

export default component.exports